import script from "./BenefitCDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitCDialog.vue?vue&type=script&setup=true&lang=js"

import "./BenefitCDialog.vue?vue&type=style&index=0&id=81258720&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81258720"]])

export default __exports__